import Link from "next/link";
import AtAGlance from "@/components/sections/products/shared/at-a-glance";
import { ROUTES, STATS } from "@/lib/constants";

const ROWS = [
  { label: "Starting price", value: "$1/GB, bandwidth rolls over" },
  { label: "Minimum purchase", value: "$25/month for 25 GB" },
  { label: "Network", value: `${STATS.ips} residential IPs` },
  { label: "Coverage", value: `${STATS.countries} countries` },
  { label: "Targeting", value: "Country, city, ISP" },
  { label: "Sessions", value: "Rotating or sticky" },
  { label: "Protocols", value: "HTTP, HTTPS, SOCKS5" },
  { label: "Authentication", value: "Username/password" },
  { label: "Renewal", value: "Monthly until canceled" },
  { label: "KYC", value: "Required before proxy access" },
  { label: "Free proxy trial", value: "None — account creation is free" },
  { label: "Refund", value: "30-day, conditional, ≤10 GB used" },
];

export default function ResidentialAtAGlance() {
  return (
    <AtAGlance
      headingId="residential-at-a-glance-heading"
      heading="Proxidize Residential Proxies at a Glance"
      intro={
        <>
          {STATS.ips} ethically sourced residential IPs with rotating and sticky sessions. Review
          all{" "}
          <Link
            href={ROUTES.pricingResidentialProxies}
            className="text-foreground decoration-foreground/30 hover:decoration-foreground underline underline-offset-4"
          >
            residential proxy pricing and plans
          </Link>
          , including minimum purchase, volume rates, rollover, and refund conditions.
        </>
      }
      rows={ROWS}
    />
  );
}
